import type { ActivityType } from '@/types'

const ACTIVITY_DESCRIPTORS: Record<ActivityType, string> = {
  paramotor: 'tandem paramotor flight over karst mountains',
  hot_air_balloon: 'hot air balloon ride with panoramic views',
  boat_cruise: 'scenic sunset cruise on Nam Ngum Lake',
  tuktuk: 'tuk tuk adventure tour through countryside',
  enduro: 'electric enduro off-road adventure on Kayo EC2i',
  package: 'adventure activity package',
  trekking: 'trekking adventure through scenic landscapes',
  rock_climbing: 'guided rock climbing on Vang Vieng limestone cliffs',
}

/**
 * Generate an SEO-friendly alt tag for an activity image.
 * Combines a descriptive phrase for the activity type with the title and location.
 *
 * Example output:
 *   "tandem paramotor flight over karst mountains - Sunset Paramotor Vang Vieng Laos - photo 2 of 5"
 */
export function activityImageAlt(
  title: string,
  opts?: {
    activityType?: ActivityType | string
    location?: string | null
    index?: number
    total?: number
  }
): string {
  const parts: string[] = []

  // Lead with a descriptive phrase based on activity type
  if (opts?.activityType && opts.activityType in ACTIVITY_DESCRIPTORS) {
    parts.push(ACTIVITY_DESCRIPTORS[opts.activityType as ActivityType])
  }

  // Activity title
  parts.push(title)

  // Location adds geographic keyword relevance
  if (opts?.location) {
    parts.push(opts.location)
  }

  // Image position within a gallery (helps differentiate in image search)
  if (opts?.index !== undefined && opts?.total && opts.total > 1) {
    parts.push(`photo ${opts.index + 1} of ${opts.total}`)
  }

  return parts.join(' - ')
}
